import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { userProductSchema } from '../schemas/user-product.schema';

/**
 * Get all the licensed products for the current authenticated user
 * @returns array of user products
 */
export function getUsersProducts(this: unknown) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).usersProductsUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(z.array(userProductSchema)));
}
